<template>
  <b-modal ref="modal" visible size="lg" :hide-footer="true" title="Locatiestickers" @hidden="$emit('close')">
      <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Locatiestickers PDF generator</h3>
        </div>
        <div class="block-content p-0">
                <div class="form-row">
                    <div class="form-group col-md-3">
                        <label for="Rijnummer">Letter:</label>
                        <input v-model="letter" type="text" class="form-control form-control-lg" placeholder="A">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-3">
                        <label for="Rijnummer">Rijnummer:</label>
                        <input v-model="rowNumber" type="Nummber" class="form-control form-control-lg" placeholder="05">
                    </div>
                      <div class="form-group col-md-3" style="margin-top: 30px">
                        <div style="display: flex;" v-if="rowNumber && letter">
                            <p>{{letter}}</p>.
                            <p style="font-weight: bold;">{{rowNumber}}</p>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-3">
                        <label for="Stellingen van">Stellingen van:</label>
                        <input v-model="racksFrom" type="number" class="form-control form-control-lg"  placeholder="01">
                    </div>

                    <div class="form-group col-md-3">
                        <label for="Stellingen tot">Stellingen tot:</label>
                        <input v-model="racksTill" type="number" class="form-control form-control-lg"  placeholder="11">
                    </div>

                    <div class="form-group col-md-3" style="margin-top: 30px">
                        <div style="display: flex;" v-if="rowNumber && racksFrom && racksTill">
                            <p>{{letter}}</p>.
                            <p>{{rowNumber}}</p>.
                            <p style="font-weight: bold;">{{racksFrom}}</p>-
                            <p>{{letter}}</p>.
                            <p>{{rowNumber}}</p>.
                            <p style="font-weight: bold;">{{racksTill}}</p>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-3">
                        <label for="Planken van">Planken van:</label>
                        <input v-model="planksFrom" type="number" class="form-control form-control-lg"  placeholder="01">
                    </div>
                    <div class="form-group col-md-3">
                        <label for="Planken tot">Planken tot:</label>
                        <input v-model="planksTill" type="number" class="form-control form-control-lg" placeholder="06">
                    </div>
                    <div class="form-group col-md-3" style="margin-top: 30px">
                        <div style="display: flex;" v-if="rowNumber && racksFrom && racksTill && planksFrom && planksTill">
                            <p>{{letter}}</p>.
                            <p>{{rowNumber}}</p>.
                            <p>{{racksFrom}}</p>.
                            <p style="font-weight: bold;">{{planksFrom}}</p>-
                            <p>{{letter}}</p>.
                            <p>{{rowNumber}}</p>.
                            <p>{{racksTill}}</p>.
                            <p style="font-weight: bold;">{{planksTill}}</p>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-3">
                        <label for="Locaties van">Locaties van</label>
                        <input v-model="locationsFrom" type="number" class="form-control form-control-lg"  placeholder="01">
                    </div>
                    <div class="form-group col-md-3">
                        <label for="Locaties tot">Locaties tot</label>
                        <input v-model="locationsTill" type="number" class="form-control form-control-lg"  placeholder="05">
                    </div>
                    <div class="form-group col-md-3" style="margin-top: 30px">
                        <div style="display: flex;" v-if="rowNumber && racksFrom && racksTill && planksFrom && planksTill && locationsTill && locationsFrom">
                            <p>{{letter}}</p>.
                            <p>{{rowNumber}}</p>.
                            <p>{{racksFrom}}</p>.
                            <p>{{planksFrom}}</p>.
                            <p style="font-weight: bold;">{{locationsFrom}}</p>-
                            <p>{{letter}}</p>.
                            <p>{{rowNumber}}</p>.
                            <p>{{racksTill}}</p>.
                            <p>{{planksTill}}</p>.
                            <p style="font-weight: bold;">{{locationsTill}}</p>
                        </div>
                    </div>
                </div>
                <button @click="generateLocationStickerPdf" type="submit" class="btn btn-primary btn-lg">Genereer PDF ({{totalStickersToBePrinted}} stickers)</button>
        </div>
      </div>
  </b-modal>
</template>

<script>
export default {
  computed: {
    totalStickersToBePrinted () {
      return ((this.racksTill - this.racksFrom) + 1) * ((this.planksTill - this.planksFrom) + 1) * ((this.locationsTill - this.locationsFrom) + 1)
    }
  },
  data () {
    return {
      letter: null,
      rowNumber: null,
      racksFrom: null,
      racksTill: null,
      planksFrom: null,
      planksTill: null,
      locationsFrom: null,
      locationsTill: null
    }
  },
  methods: {
    generateLocationStickerPdf () {
      const data = {
        letter: this.letter,
        rowNumber: this.rowNumber,
        racksFrom: this.racksFrom,
        racksTill: this.racksTill,
        planksFrom: this.planksFrom,
        planksTill: this.planksTill,
        locationsFrom: this.locationsFrom,
        locationsTill: this.locationsTill
      }
      this.$http.post(`/encode-location-data`, data)
        .then((response) => {
          window.open(`${process.env.API_URL}/location-stickers/${response.data.data}`)
          this.$refs.modal.hide()
        })
        .catch(() => {
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het aanmaken van de PDF. Probeer het opnieuw.`, 'error')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// LocationStickerGenerator.vue?2f4801c9